import { convertToGAIndex, sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
var EVENT_CATEGORY = 'Navigation - MDD';
var compareNavItems = function compareNavItems(a, b) {
  return a.title === b.title && a.url === b.url;
};
var formatEventLabel = function formatEventLabel(data) {
  return data.join('|');
};
var getLabelForColumnSection = function getLabelForColumnSection(_ref) {
  var columnSection = _ref.columnSection,
    columnSectionIndex = _ref.columnSectionIndex,
    columnSectionsIndex = _ref.columnSectionsIndex,
    navItem = _ref.navItem,
    navItemIndex = _ref.navItemIndex,
    search = _ref.search;
  return columnSection.items.reduce(function (result, columnItem, columnItemIndex) {
    return result !== null && result !== void 0 ? result : compareNavItems(columnItem, search) ? formatEventLabel([convertToGAIndex(3), convertToGAIndex(navItemIndex), navItem.title, convertToGAIndex(columnSectionsIndex), convertToGAIndex(columnSectionIndex), columnSection.title, convertToGAIndex(columnItemIndex), columnItem.title]) : null;
  }, null);
};
var getLabelForColumnSections = function getLabelForColumnSections(_ref2) {
  var columnSections = _ref2.columnSections,
    columnSectionsIndex = _ref2.columnSectionsIndex,
    navItem = _ref2.navItem,
    navItemIndex = _ref2.navItemIndex,
    search = _ref2.search;
  return columnSections.reduce(function (result, columnSection, columnSectionIndex) {
    return result !== null && result !== void 0 ? result : compareNavItems(columnSection, search) ? formatEventLabel([convertToGAIndex(2), convertToGAIndex(navItemIndex), navItem.title, convertToGAIndex(columnSectionsIndex), convertToGAIndex(columnSectionIndex), columnSection.title]) : getLabelForColumnSection({
      columnSectionsIndex,
      columnSection,
      columnSectionIndex,
      search,
      navItem,
      navItemIndex
    });
  }, null);
};
var getLabelForNavItem = function getLabelForNavItem(_ref3) {
  var navItem = _ref3.navItem,
    navItemIndex = _ref3.navItemIndex,
    search = _ref3.search;
  return navItem.columns.reduce(function (columnSectionsResult, columnSections, columnSectionsIndex) {
    return columnSectionsResult !== null && columnSectionsResult !== void 0 ? columnSectionsResult : getLabelForColumnSections({
      search,
      navItem,
      navItemIndex,
      columnSectionsIndex,
      columnSections
    });
  }, null);
};
var getTrackingEventLabel = function getTrackingEventLabel(navData, search) {
  return navData.reduce(function (result, navItem, navItemIndex) {
    return result !== null && result !== void 0 ? result : compareNavItems(navItem, search) ? formatEventLabel([convertToGAIndex(0), convertToGAIndex(navItemIndex), navItem.title]) : getLabelForNavItem({
      search,
      navItem,
      navItemIndex
    });
  }, null);
};
export var clickLink = function clickLink(evt, navigationData, item) {
  return sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Click',
    event_label: getTrackingEventLabel(navigationData, item),
    destination_URL: item.url
  });
};
export var hoverLink = function hoverLink(departmentIndex, item) {
  return sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Hover',
    event_label: "".concat(convertToGAIndex(departmentIndex), "|").concat(item.title)
  });
};